import "./style.scss";

import StyledButton from "components/shared/StyledButton";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import QRCodeCanvas from "qrcode.react";
import { useTranslation } from "react-i18next";

type TProps = {
    handleSubmit: () => void;
    onMFAVerificationCode: (ev: any) => void;
    mfaVerificationCode: string;
    mfaQRCode: string;
};
const SetupMFAModal = ({ handleSubmit, onMFAVerificationCode, mfaVerificationCode, mfaQRCode }: TProps) => {
    const [t] = useTranslation();

    return (
        <>
            <div className="das2-export">
                <center>
                    <QRCodeCanvas value={mfaQRCode} />
                </center>

                <div className="das2-export-mfa-explanation">
                    <div style={{ marginBottom: "16px" }}>{t("Settings.MFAModalDescription")}</div>

                    <div className="create-key-input">
                        <label className="create-key-input-label" htmlFor="">
                            {t("Settings.MFAVerificationCode")}
                        </label>
                        <StyledTextField
                            fullWidth
                            value={mfaVerificationCode ?? ""}
                            onChange={(ev) => onMFAVerificationCode(ev.target.value)}
                            placeholder={t("Settings.MFAVerificationCode")}
                        />
                    </div>
                </div>

                <StyledButton
                    buttonType="primary"
                    disabled={!mfaVerificationCode}
                    fullWidth
                    onClick={() => handleSubmit()}
                >
                    {t("Settings.Confirm")}
                </StyledButton>
            </div>
        </>
    );
};

export default SetupMFAModal;
